import {
  FormSelect,
  FormInput,
  DataTable,
  Dialog,
  FormDatePicker,
  Loader,
  FormPhoneInput,
} from "@/components";
import { Button, DialogClose, DialogFooter } from "@/components/ui";
import { FormProvider } from "react-hook-form";
import useAssignBOM from "./useAssignBom";
import {
  FIRST_NAME,
  SEARCH_TYPE,
  searchType,
  LAST_NAME,
  SEARCH_CRITERIA,
  BOM_POSITION_ID,
  END_DATE,
  START_DATE,
} from "./consts";
import moment from "moment";

const AssignBOM = ({ onCancel }: { onCancel: () => void }) => {
  const {
    form,
    columns,
    onSubmit,
    requiredFields,
    rowSelection,
    setRowSelection,
    onClear,
    onAssignBOM,
    open,
    setOpen,
    requiredAddBomFields,
    addForm,
    onCloseDialog,
    onSubmitAddBOM,
    isAssignPending,
    isCommunityUsersLoading,
    bomPositions,
    isBOMPositionsLoading,
    communityUsersList,
  } = useAssignBOM({ onCancel });
  const { errors } = form.formState;
  const { errors: addErrors } = addForm.formState;

  return (
    <div className="flex flex-col gap-5">
      {isCommunityUsersLoading ? (
        <Loader />
      ) : (
        <>
          <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)}>
              <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]">
                <div>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
                    <FormSelect
                      name={SEARCH_TYPE}
                      control={form.control}
                      label="Search Type"
                      placeholder="Please select"
                      error={errors[SEARCH_TYPE]?.message}
                      isRequired={requiredFields.includes(SEARCH_TYPE)}
                      options={searchType}
                      onChange={() => {
                        form.setValue(SEARCH_CRITERIA, "");
                      }}
                    />
                    {form.watch(SEARCH_TYPE) == "name" ? (
                      <>
                        <FormInput
                          name={FIRST_NAME}
                          control={form.control}
                          label="First Name"
                          placeholder="Please enter"
                          error={errors[FIRST_NAME]?.message}
                          isRequired={requiredFields.includes(FIRST_NAME)}
                        />
                        <FormInput
                          name={LAST_NAME}
                          control={form.control}
                          label="Last Name"
                          placeholder="Please enter"
                          error={errors[LAST_NAME]?.message}
                          isRequired={requiredFields.includes(LAST_NAME)}
                        />
                      </>
                    ) : form.watch(SEARCH_TYPE) == "mobileNo" ? (
                      <FormPhoneInput
                        name={SEARCH_CRITERIA}
                        control={form.control}
                        label="Search Criteria"
                        placeholder="Please enter"
                        error={errors[SEARCH_CRITERIA]?.message}
                        isRequired={requiredFields.includes(SEARCH_CRITERIA)}
                      />
                    ) : (
                      <FormInput
                        name={SEARCH_CRITERIA}
                        control={form.control}
                        label="Search Criteria"
                        placeholder="Please enter"
                        error={errors[SEARCH_CRITERIA]?.message}
                        isRequired={requiredFields.includes(SEARCH_CRITERIA)}
                        type={
                          form.watch(SEARCH_TYPE) === "email" ? "email" : "text"
                        }
                      />
                    )}
                  </div>
                  <div className="flex flex-row justify-end gap-3 pt-3">
                    <Button type="submit">Search</Button>
                    <Button variant="outline" type="button" onClick={onClear}>
                      Clear
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          </FormProvider>

          <DataTable
            columns={columns}
            data={communityUsersList}
            rowSelection={rowSelection}
            setRowSelection={setRowSelection}
          />
          <div className="flex flex-row justify-end gap-3 pt-3">
            <Button variant="outline" type="button" onClick={onCancel}>
              Cancel
            </Button>
            <Button onClick={onAssignBOM}>Assign BM</Button>
          </div>
        </>
      )}
      <Dialog
        open={open}
        setOpen={setOpen}
        title="Assign BM Position"
        hideFooter
      >
        {isBOMPositionsLoading ? (
          <Loader />
        ) : (
          <FormProvider {...addForm}>
            <form onSubmit={addForm.handleSubmit(onSubmitAddBOM)}>
              <div className="grid grid-cols-1 gap-[30px]">
                <FormSelect
                  name={BOM_POSITION_ID}
                  control={addForm.control}
                  label="Position"
                  placeholder="Please select"
                  error={addErrors[BOM_POSITION_ID]?.message}
                  isRequired={requiredAddBomFields.includes(BOM_POSITION_ID)}
                  options={bomPositions?.data?.map((position: any) => ({
                    label: position?.positionName,
                    value: position?.bomPositionId?.toString(),
                  }))}
                />
                <FormDatePicker
                  name={START_DATE}
                  control={addForm.control}
                  label="Start Date"
                  placeholder="Please select"
                  error={addErrors[START_DATE]?.message}
                  isRequired={true}
                  maxDate={new Date()}
                  onClear={() => addForm.setValue(END_DATE, "")}
                  onChange={(date: any) => {
                    if (moment(date).isAfter(addForm.getValues()[END_DATE])) {
                      addForm.setValue(END_DATE, "");
                    }
                  }}
                />
                <FormDatePicker
                  name={END_DATE}
                  control={addForm.control}
                  label="End Date"
                  placeholder="Please select"
                  error={addErrors[END_DATE]?.message}
                  isRequired={requiredAddBomFields.includes(END_DATE)}
                  minDate={new Date(addForm.watch(START_DATE))}
                  disabled={!addForm.watch(START_DATE)}
                />
              </div>
              <DialogFooter className="mt-5">
                <DialogClose>
                  <Button
                    type="button"
                    variant="outline"
                    disabled={isAssignPending}
                    onClick={onCloseDialog}
                  >
                    Cancel
                  </Button>
                </DialogClose>
                <Button type="submit" disabled={isAssignPending}>
                  {isAssignPending && <Loader variant="secondary" />} Submit
                </Button>
              </DialogFooter>
            </form>
          </FormProvider>
        )}
      </Dialog>
    </div>
  );
};

export default AssignBOM;
